import { toCanvas } from "html-to-image";
import jsPDF from "jspdf";
import { Employee } from "../../types/processTypes";
import { Company } from "../../../setups/types/setupTypes";

const PDF_IMAGE_OPTS = {
  format: "PNG" as const,
  x: 4,
  y: 4,
  width: 200,
  height: 290,
  compression: "FAST" as const,
};

function queryInRoot(root: HTMLElement | Document, id: string): HTMLElement | null {
  return root.querySelector(`#${id}`) as HTMLElement | null;
}

/** Matches PremiumTemplate download naming: `EXP CV Acme (Jane Doe)`. */
export function buildBulkCvFileName(employee: Employee, company: Company): string {
  const exp =
    (employee.workExperience?.length ?? 0) > 0 ? "EXP" : "NON EXP";
  const displayName = company.displayName ?? "";
  const space = displayName.indexOf(" ");
  const compName =
    space >= 0 ? displayName.substring(0, space) : displayName;
  return `${exp} CV ${compName} (${employee.givenName} ${employee.surName})`;
}

export async function buildAndSavePdfFromDom(
  fileName: string,
  numberOfPages: number,
  root?: HTMLElement | null,
): Promise<void> {
  const scope: HTMLElement | Document = root ?? document;
  const personalEl = queryInRoot(scope, "personalData");
  if (!personalEl) return;

  // Match PremiumTemplate: plain toCanvas — extra options/DOM mutation blank photos.
  const doc = new jsPDF("p", "mm", "a4", false);
  const canvas1 = await toCanvas(personalEl);
  doc.addImage({
    imageData: canvas1.toDataURL("image/png"),
    ...PDF_IMAGE_OPTS,
    alias: "alias1",
  });

  if (numberOfPages >= 2) {
    const passportEl = queryInRoot(scope, "passportData");
    if (passportEl) {
      doc.addPage();
      const canvas2 = await toCanvas(passportEl);
      doc.addImage({
        imageData: canvas2.toDataURL("image/png"),
        ...PDF_IMAGE_OPTS,
        alias: "alias2",
      });
    }
  }

  if (numberOfPages >= 3) {
    const medicalEl = queryInRoot(scope, "medicalData");
    if (medicalEl) {
      doc.addPage();
      const canvas3 = await toCanvas(medicalEl);
      doc.addImage({
        imageData: canvas3.toDataURL("image/png"),
        ...PDF_IMAGE_OPTS,
        alias: "alias3",
      });
    }
  }

  doc.save(`${fileName}.pdf`);
}
